export default {
  title: 'Biometric data verification',
  titleDescription: 'It is necessary to verify the identity of the beneficiary to continue',
  allowCamera: 'Allow access to the camera in your browser',
  tabs: {
    facial: 'Facial recognition',
    finger: 'Fingerprint'
  },
  buttons: {
    capture: 'Capture',
    retry: 'Try again',
    confirm: 'Confirm'
  },
  biometricValidation: {
    success: 'Successful verification',
    fail: 'Verification failed'
  },
  instructions: {
    title: 'Biometric data of the beneficiary',
    subtitle: "It is necessary to capture the person's face to verify their identity",
    buttonLabel: 'Start',
    steps: {
      step1: {
        title: 'Step 1',
        description: "Place the camera at the level of the insured's face"
      },
      step2: {
        title: 'Step 2',
        description: 'Make sure there is enough light'
      },
      step3: {
        title: 'Step 3',
        description: 'Frame the face within the limits shown'
      }
    }
  },
  captureFinger: 'Start fingerprint capture',
  fingerprint: {
    title: 'Beneficiary Biometric Data',
    subtitle: 'It is necessary to capture the fingerprint to verify their identity',
    buttonLabel: 'Start',
    steps: {
      step1: {
        title: 'Step 1',
        description: "Position the insured person's finger firmly on the fingerprint reader"
      },
      step2: {
        title: 'Step 2',
        description: 'Ensure the finger is clean and dry for accurate capture'
      },
      step3: {
        title: 'Step 3',
        description: 'Ensure the finger is completely covered by the reader'
      }
    },
    errors: {
      initializedFingerprintDevice:
        'The device is not initialized or connected. Please check the connection and try again.',
      timeOutFingerprintDevice: 'Fingerprint capture timed out. Please try again.',
      agentNotConfigured:
        'The fingerprint service is not installed or not responding. Please check the configuration and try again.',
      captureAlreadyStarted:
        'Capture already started. Please stop the current capture before starting a new one.',
      captureStop: 'Capture has stopped. Please try again.',
      defaultError: 'Something went wrong with the fingerprint capture. Please try again.'
    }
  }
}
